import React from 'react';
import { Box, Stack, useRadio, useRadioGroup, UseRadioProps, Icon } from '@chakra-ui/react';
import { CheckCircleIcon } from '@chakra-ui/icons';

interface CustomRadioProps extends UseRadioProps {
  children: React.ReactNode;
}

const CustomRadio: React.FC<CustomRadioProps> = props => {
  const { getInputProps, getRadioProps } = useRadio(props);

  const input = getInputProps();
  const checkbox = getRadioProps();

  return (
    <Box as="label" width="100%">
      <input {...input} />
      <Box
        {...checkbox}
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        borderWidth="1px"
        borderRadius="md"
        boxShadow="sm"
        cursor="pointer"
        bg="white"
        px={4}
        py={3}
        _checked={{
          bg: 'gray.100',
          borderColor: 'gray.400',
        }}
        _focus={{
          boxShadow: 'outline',
        }}
        _hover={{
          borderColor: 'gray.300',
        }}
      >
        {props.children}
        {props.isChecked && <Icon as={CheckCircleIcon} color="gray.800" />}
      </Box>
    </Box>
  );
};

// Интерфейс для пропсов CustomRadioGroup
interface CustomRadioGroupProps {
  value: string;
  onChange: (value: string) => void;
}

const CustomRadioGroup: React.FC<CustomRadioGroupProps> = ({ value, onChange }) => {
  const options = ['Брак', 'Не комплект', 'Товар не соответствует заказу', 'Другая причина'];

  const { getRootProps, getRadioProps } = useRadioGroup({
    name: 'reason',
    value,
    onChange,
  });

  const group = getRootProps();

  return (
    <Stack {...group} spacing={4}>
      {options.map(val => {
        const radio = getRadioProps({ value: val });
        return (
          <CustomRadio key={val} {...radio}>
            {val}
          </CustomRadio>
        );
      })}
    </Stack>
  );
};

export default CustomRadioGroup;
